// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"DefaultLayout_col-md-4__laC9_","main":"DefaultLayout_main__HDlyD"};